import { isAxiosError } from 'axios';

/**
 * Extract a human-readable error message from an API error.
 *
 * Checks (in order):
 * 1. Axios response body `detail` (FastAPI HTTPException / DoseSpot errors)
 * 2. Axios response body `message` (legacy error format)
 * 3. Native Error.message
 * 4. Fallback string
 */
export function extractApiErrorMessage(
  err: unknown,
  fallback = 'An unexpected error occurred.'
): string {
  if (isAxiosError(err)) {
    const data: unknown = err.response?.data;
    if (data != null && typeof data === 'object') {
      const record = data as Record<string, unknown>;
      if (typeof record['detail'] === 'string' && record['detail'].length > 0) {
        return record['detail'];
      }
      if (
        typeof record['message'] === 'string' &&
        record['message'].length > 0 &&
        record['message'] !== 'an error occurred'
      ) {
        return record['message'];
      }
    }
  }

  if (err instanceof Error && err.message) {
    return err.message;
  }

  if (typeof err === 'string' && err.length > 0) {
    return err;
  }

  return fallback;
}
